const MS4s = () => {
  const MS4sData = [
    {
      "agency": "Arapahoe County",
      "total_construction_sites": 40,
      "construction_inspections_count": 425,
      "construction_enforcement_count": 5,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Douglas County",
      "total_construction_sites": "1,220",
      "construction_inspections_count": "7,474",
      "construction_enforcement_count": 334,
      "construction_bmps_count": 151,
      "permanent_inspections_count": 95,
      "permanent_enforcement_count": 26
    },
    {
      "agency": "City of Aurora",
      "total_construction_sites": 53,
      "construction_inspections_count": 538,
      "construction_enforcement_count": 21,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "SEMSWA (City of Centennial)",
      "total_construction_sites": 67,
      "construction_inspections_count": 788,
      "construction_enforcement_count": 9,
      "construction_bmps_count": 9,
      "permanent_inspections_count": 39,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Greenwood Village",
      "total_construction_sites": 0,
      "construction_inspections_count": 0,
      "construction_enforcement_count": 0,
      "construction_bmps_count": 23,
      "permanent_inspections_count": 16,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Lone Tree",
      "total_construction_sites": 8,
      "construction_inspections_count": 130,
      "construction_enforcement_count": 0,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 0,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "City of Castle Pines",
      "total_construction_sites": 17,
      "construction_inspections_count": "133*",
      "construction_enforcement_count": "106**",
      "construction_bmps_count": 3,
      "permanent_inspections_count": 3,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Town of Castle Rock",
      "total_construction_sites": "2,401",
      "construction_inspections_count": "5,002",
      "construction_enforcement_count": "1,455",
      "construction_bmps_count": 18,
      "permanent_inspections_count": 295,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "Town of Parker",
      "total_construction_sites": 152,
      "construction_inspections_count": "1,884",
      "construction_enforcement_count": 51,
      "construction_bmps_count": 13,
      "permanent_inspections_count": 327,
      "permanent_enforcement_count": 0
    },
    {
      "agency": "CDOT",
      "total_construction_sites": 5,
      "construction_inspections_count": 38,
      "construction_enforcement_count": 0,
      "construction_bmps_count": 0,
      "permanent_inspections_count": 2,
      "permanent_enforcement_count": 0
    }
  ];

   // Declare and configure request overview table
   const MS4sTable = new requestTable({
    container: "#ms4s-table",
    filterEnabled: false,
    tableHeaders: {
      "agency": "Agency",
      "total_construction_sites": "Total Construction Sites",
      "construction_inspections_count": "Construction Inspections",
      "construction_enforcement_count": "Construction Enforcements",
      "construction_bmps_count": "Permanent BMPs",
      "permanent_inspections_count": "Permanent Inspections",
      "permanent_enforcement_count": "Permanent Enforcements"
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
